import { useEffect } from 'react';
import Login from './Pages/Login/Login';
import { Route, Routes, useLocation } from "react-router-dom";
import { NoChrome } from './Contexts/ChromeContext';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import Start2 from './Pages/Start2/Start2';
import FeaturesMemberOrganisationsSe from './Pages/Features/FeaturesMemberOrganisationsSe';
import Create from './Pages/Create/Create';
import Event from './Pages/Event/Event';
import EventAnsweredComplete from './Pages/Event/EventAnsweredComplete';
import CreateUser from './Pages/NewUser/CreateUser';
import NewUserCreated from './Pages/NewUser/NewUserCreated';
import AdminStart from './PagesAdmin/Start/Start';
import MyEvents from './PagesAdmin/Events/MyEvents';
import MyEventDetails from './PagesAdmin/Events/MyEventDetails';
import Pricing from './Pages/Pricing/Pricing';
import ConfirmEmail from './Pages/ConfirmEmail/ConformEmail';
import MyEventEdit from './PagesAdmin/Events/MyEventEdit';
import NewUserCreatedWithProvider from './Pages/NewUser/NewUserCreatedWithProvider';
import CompleteExternalRegistration from './Pages/NewUser/CompleteExternalRegistration';
import Terms from './Pages/Terms/Terms';
import Contact from './Pages/Contact/Contact';
import Help from './Pages/Help/Help';
import PurchaseComplete from './Pages/Pricing/PurchaseComplete';
import Settings from './PagesAdmin/Account/Settings';
import FinalizePremiumRegistration from './Pages/FinalizePayment/FinalizeRegistration';
import ResetPassword from './Pages/ForgotPassword/ResetPassword';
import AdminGroups from './PagesAdmin/Users/Groups';
import Privacy from './Pages/Privacy/Privacy';
import ReactGA from 'react-ga'
import AdminPage from './Admin/AdminPage';
import AdminUsers from './PagesAdmin/Users/Users';
import Documents from './PagesAdmin/Documents/Documents';
import Administrators from './PagesAdmin/Account/Admins';
import CreateCompanyUser from './Pages/NewUser/CreateCompanyUser';
import PublicSite from './PagesAdmin/Account/PublicSite';
import PublicSiteLogin from './Pages/PublicSite/PublicSiteLogin';
import PublicSiteNewMember from './Pages/PublicSite/PublicSiteNewMember';
import PublicSiteMemberSearch from './Pages/PublicSite/PublicSiteMemberSearch';
import PublicSiteFamilyMembersPage from './Pages/PublicSite/PublicSiteFamilyMembersPage';
import PublicSitePaymentsPage from './Pages/PublicSite/PublicSitePaymentsPage';
import PublicSiteEventsPage from './Pages/PublicSite/PublicSiteEventsPage';
import MemberSettings from './PagesAdmin/Account/MemberSettings';
import AdminSendEmailCategory from './PagesAdmin/Communicate/SendEmailCategory';
import AdminSendEmailMember from './PagesAdmin/Communicate/SendEmailMember';
import UploadMembers from './Components/Users/UploadMembers/UploadMembers';
import UploadPayments from './Components/Users/UploadPayments/UploadPayments';
import PublicSiteNewMemberActivateAccount from './Pages/PublicSite/NewMemberActiveteAccount';
import PublicSiteConfirmEmailChange from './Pages/PublicSite/PublicSiteConfirmEmailChange';
import PublicSiteResult from './Pages/PublicSite/PublicSiteResultPage';
import PublicSiteCustomList from './Pages/PublicSite/PublicSiteCustomList';
import AdminEmailTemplates from './PagesAdmin/Account/EmailTemplates';
import AdminAutomaticSending from './PagesAdmin/Account/AutomaticSending';
import AdminEmailTemplatesAndAutomation from './PagesAdmin/Account/EmailTemplatesAndAutomation';
import MemberFormSettings from './PagesAdmin/Account/MemberFormSettings';
import AdminSendEmailExternal from './PagesAdmin/Communicate/SendEmailExternal';
import AdminEmailLogs from './PagesAdmin/Communicate/EmailLogs';
import AdminCommunicationHistory from './PagesAdmin/Communicate/CommunicationHistory';
import AdminBatchJobHistory from './PagesAdmin/Communicate/BatchJobHistory';
import AdminEmailFollowUp from './PagesAdmin/Communicate/EmailFollowUp';
import AdminBatchJobStatus from './PagesAdmin/Communicate/BatchJobStatus';
import AdminUserHistory from './PagesAdmin/Users/UserHistory';
import CustomListHistory from './PagesAdmin/Users/CustomListHistory';
import Payments from './PagesAdmin/Account/Payment';
import PaymentConfirmation from './PagesAdmin/Account/PaymentConfirmation';
import FeaturesMemberOrganisations from './Pages/Features/FeaturesMemberOrganisations';
import FeaturesCompanies from './Pages/Features/FeaturesCompanies';
import MyEventDetailsInvites from './PagesAdmin/Events/MyEventDetailsInvites';
import MyEventDetailsSendInviteExternal from './PagesAdmin/Events/MyEventDetailsSendInviteExternal';
import MyEventDetailsSendInviteGroup from './PagesAdmin/Events/MyEventDetailsSendInviteGroup';
import MyEventDetailsSendInviteMember from './PagesAdmin/Events/MyEventDetailsSendInviteMember';
import Terms_En from './Pages/Terms/Terms_en';
import Privacy_En from './Pages/Privacy/Privacy_En';
import MyEventBranding from './PagesAdmin/Events/MyEventsBranding';
import AdminIntegrations from './PagesAdmin/Account/Integrations';
import FortnoxMismatchReport from './PagesAdmin/Account/FortnoxMismatchReport';
import AdminSendSmsCategory from './PagesAdmin/Communicate/SendSmsCategory';
import AdminSendSmsExternal from './PagesAdmin/Communicate/SendSmsExternal';
import AdminSendSmsMember from './PagesAdmin/Communicate/SendSmsMember';
import GDPR from './Pages/GDPR/GDPR';
import PartnerFortnox from './Pages/Partners/Fortnox';
import AdminCreatePaymentLinks from './PagesAdmin/Payments/AdminCreatePaymentLinks';
import AdminCreateFortnoxInvoices from './PagesAdmin/Payments/AdminCreateFortnoxInvoices';
import AdminCreateSpirisInvoices from './PagesAdmin/Payments/AdminCreateSpirisInvoices';
import Backups from './PagesAdmin/Account/Backup';
import CreatePingPaymentIntegration from './PagesAdmin/Account/CreatePingPaymentIntegration';
import AdminPictureArchive from './PagesAdmin/Users/PictureArchive';
import PartnerPingPayments from './Pages/Partners/PingPayments';
import CustomListSettings from './PagesAdmin/Account/CustomListSettings';
import EditCustomList from './PagesAdmin/Account/EditCustomList';
import CustomList from './Pages/CustomList/CustomList';
import MembershipProducts from './PagesAdmin/Users/MembershipProducts';
import MemberDetails from './PagesAdmin/Users/MemberDetails';
import Views from './PagesAdmin/Account/Views';
import { PublicSiteMemberAuthGuard } from './Components/PublicSite/PublicSiteMemberAuthGuard';
import { PublicSiteMemberLanding } from './Components/PublicSite/PublicSiteMemberLanding';
import MemberSystemForAssociationsPage from './Pages/Articles/MemberManagementSystem';
import MemberManagemenIntegrations from './Pages/Articles/MemberManagemenIntegrations';
import MemberSystemSafety from './Pages/Articles/MemberManagementSafety';
import PartnerSpiris from './Pages/Partners/Spiris';
import PingPaymentPaymentReport from './PagesAdmin/Reports/PingPaymentPaymentReport';

// Public, member-facing site pages (accessed via /:companyurl/...). Their page elements below are each
// wrapped in <NoChrome> so the admin header/footer hides itself while one of them is mounted - see
// Contexts/ChromeContext.tsx.
const publicSiteLoginPaths = ["/:companyurl/login", "/:lang/:companyurl/login"];
const publicSiteLoginWithCodePaths = ["/:companyurl/login/:passwordcode", "/:lang/:companyurl/login/:passwordcode"];
const publicSiteEditMemberLoginPaths = ["/:companyurl/editmember/:passwordcode", "/:lang/:companyurl/editmember/:passwordcode"];
const publicSiteEditMemberPaths = ["/:companyurl/editmember", "/:lang/:companyurl/editmember"];
const publicSiteNewMemberPaths = ["/:companyurl/newmember", "/:lang/:companyurl/newmember"];
const publicSiteNewMemberActivatePaths = ["/:companyurl/newmemberactiveaccount/:passwordcode", "/:lang/:companyurl/newmemberactiveaccount/:passwordcode"];
const publicSiteConfirmEmailChangePaths = ["/:companyurl/confirmemailchange/:code", "/:lang/:companyurl/confirmemailchange/:code"];
const publicSiteMemberSearchPaths = ["/:companyurl/membersearch", "/:lang/:companyurl/membersearch"];
const publicSiteFamilyMembersPaths = ["/:companyurl/familymembers", "/:lang/:companyurl/familymembers"];
const publicSitePaymentsPaths = ["/:companyurl/payments", "/:lang/:companyurl/payments"];
const publicSiteEventsPaths = ["/:companyurl/events", "/:lang/:companyurl/events"];
const publicSiteCustomListPaths = ["/:companyurl/public-customlist/:customListId", "/:lang/:companyurl/public-customlist/:customListId"];
const publicSiteResultPaths = ["/:companyurl/succes/:successCode", "/:lang/:companyurl/success/:successCode"];

const NavigationRoutes = () => {
    ReactGA.initialize("G-BWZH8XKY95");
    const location = useLocation();
    useEffect(() => {
        if (window.location.href.indexOf("onefront360.com") != -1) {
            ReactGA.set({ page: location.pathname })
            ReactGA.pageview(location.pathname)
        }
    }, [location]);

    const MultiRoute = (element: JSX.Element, paths: string[]) => {
        return paths.map((p) => <Route key={p} element={element} path={p} />);
    };

    return (
        <Routes>
            {MultiRoute(<Start2 />, ["/", "/:lang/"])}
            {/* Old preview urls from before Start2 became the start page. */}
            {MultiRoute(<Start2 />, ["/se/start2", "/en/start2"])}
            {/* Explicit en/se literals instead of the ":lang" wildcard here - ":lang" matches ANY string
                (e.g. "acme"), so "/:lang/Login" used to collide with a real company's public login at
                "/acme/login" (React Router ranks them an exact tie, falls back to declaration order, and
                this admin route was registered first). "en"/"se" are the only two language codes the app
                recognizes (see Helpers/RouteHelper.ts) and can never be a real company's url, so pinning
                them as literals removes that collision for any actual company - while matching stays
                case-insensitive (React Router's default) so "/se/login", "/se/Login", "/SE/Login" etc. all
                still reach this admin page, same as before, via the same declaration-order tie-break. */}
            {MultiRoute(<Login />, ["/Login", "/en/Login", "/se/Login"])}
            {MultiRoute(<Login />, ["/Logout", "/en/Logout", "/se/Logout"])}
            {MultiRoute(<Login />, ["/Login/error/:errorid", "/en/Login/error/:errorid", "/se/Login/error/:errorid"])}
            {MultiRoute(<ForgotPassword />, ["/ForgotPassword", "/:lang/ForgotPassword/"])}
            {MultiRoute(<ResetPassword />, ["/ResetPassword", "/:lang/ResetPassword/"])}
            {MultiRoute(<CreateUser />, ["/CreateUser", "/:lang/CreateUser/"])}
            {MultiRoute(<CreateCompanyUser />, ["/CreateCompanyUser/:companyInviteId", "/:lang/CreateCompanyUser/:companyInviteId"])}
            {MultiRoute(<CreateUser />, ["/CreateUser/error/:errorid", "/:lang/CreateUser/error/:errorid"])}
            {MultiRoute(<NewUserCreated />, ["/NewUserCreated", "/:lang/NewUserCreated"])}
            {MultiRoute(<NewUserCreatedWithProvider />, ["/NewUserCreatedWithProvider", "/:lang/NewUserCreatedWithProvider"])}
            {MultiRoute(<CompleteExternalRegistration />, ["/CompleteExternalRegistration", "/:lang/CompleteExternalRegistration"])}
            {MultiRoute(<FinalizePremiumRegistration />, ["/finalizepremiumregistration", "/:lang/finalizepremiumregistration"])}
            {MultiRoute(<Create />, ["/create", "/:lang/create"])}
            {/* Event.tsx is the public invite/RSVP page - anonymous invitees view it, and it has no
                admin/auth branching at all, so it should never show the admin header/footer. */}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/Event/:id", "/:lang/Event/:id"])}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/Event/:companyurl/:id", "/:lang/:companyurl/Event/:id"])}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/:companyurl/Event/:id/invite/:inviteId", "/:lang/:companyurl/Event/:id/invite/:inviteId"])}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/Event/:id/invite/:inviteId", "/:lang/Event/:id/invite/:inviteId"])}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/:companyurl/Event/:id/reply/:authCode", "/:lang/:companyurl/Event/:id/reply/:authCode"])}
            {MultiRoute(<NoChrome><Event /></NoChrome>, ["/Event/:id/reply/:authCode", "/:lang/Event/:id/reply/:authCode"])}
            {MultiRoute(<NoChrome><EventAnsweredComplete /></NoChrome>, ["/Event/Completed", "/:lang/Event/Completed"])}
            {MultiRoute(<AdminStart />, ["/admin/start", "/:lang/admin/start"])}
            {MultiRoute(<AdminGroups />, ["/groups", "/:lang/groups"])}
            {MultiRoute(<AdminUsers />, ["/users", "/:lang/users"])}
            {MultiRoute(<MemberDetails />, ["/users/:id", "/:lang/users/:id"])}
            {MultiRoute(<MembershipProducts />, ["/membershipproducts", "/:lang/membershipproducts"])}
            {MultiRoute(<AdminPictureArchive />, ["/picturearchive", "/:lang/picturearchive"])}
            {MultiRoute(<AdminUserHistory />, ["/userHistory", "/:lang/userHistory"])}
            {MultiRoute(<CustomListHistory />, ["/customListHistory", "/:lang/customListHistory"])}
            {MultiRoute(<Administrators />, ["/admins", "/:lang/admins"])}
            {MultiRoute(<Documents />, ["/documents", "/:lang/documents"])}
            {MultiRoute(<AdminSendEmailCategory />, ["/sendEmail", "/:lang/sendEmail"])}
            {MultiRoute(<AdminSendEmailMember />, ["/sendEmailUser", "/:lang/sendEmailUser"])}
            {MultiRoute(<AdminSendEmailExternal />, ["/sendEmailExternal", "/:lang/sendEmailExternal"])}
            {MultiRoute(<AdminEmailFollowUp />, ["/emailFollowUp", "/:lang/emailFollowUp"])}
            {MultiRoute(<AdminEmailLogs />, ["/emailLogs", "/:lang/emailLogs"])}
            {MultiRoute(<AdminCommunicationHistory />, ["/communicationArchive", "/:lang/communicationArchive"])}
            {MultiRoute(<AdminBatchJobHistory />, ["/batchJobHistory", "/:lang/batchJobHistory"])}
            {MultiRoute(<AdminBatchJobStatus />, ["/batchJobStatus/:id", "/:lang/batchJobStatus/:id"])}
            {MultiRoute(<MyEvents />, ["/myevents", "/:lang/myevents/"])}
            {MultiRoute(<MyEvents />, ["/myevents/created/:newid", "/:lang/myevents/created/:newid"])}
            {MultiRoute(<MyEventDetails />, ["/myevents/:id", "/:lang/myevents/:id"])}
            {/* /participants and /reminders are older addresses of the same page. */}
            {MultiRoute(<MyEventDetailsInvites />, ["/myevents/:id/invites", "/:lang/myevents/:id/invites", "/myevents/:id/participants", "/:lang/myevents/:id/participants", "/myevents/:id/reminders", "/:lang/myevents/:id/reminders"])}
            {MultiRoute(<MyEventDetailsSendInviteExternal />, ["/myevents/:id/sendinviteexternal", "/:lang/myevents/:id/sendinviteexternal"])}
            {MultiRoute(<MyEventDetailsSendInviteGroup />, ["/myevents/:id/sendinvitegroup", "/:lang/myevents/:id/sendinvitegroup"])}
            {MultiRoute(<MyEventDetailsSendInviteMember />, ["/myevents/:id/sendinvitemember", "/:lang/myevents/:id/sendinvitemember"])}
            {MultiRoute(<MyEventEdit />, ["/myevents/:id/edit", "/:lang/myevents/:id/edit"])}
            {MultiRoute(<MyEventBranding />, ["/myevents/:id/design", "/:lang/myevents/:id/design", "/myevents/:id/branding", "/:lang/myevents/:id/branding"])}
            {MultiRoute(<Pricing />, ["/pricing", "/:lang/pricing"])}
            {MultiRoute(<PurchaseComplete />, ["/pricing/purchasecomplete", "/:lang/pricing/purchasecomplete"])}
            {MultiRoute(<Settings />, ["/settings", "/:lang/settings"])}
            {MultiRoute(<MemberSettings />, ["/memberSettings", "/:lang/memberSettings"])}
            {MultiRoute(<ConfirmEmail />, ["/confirmEmail/:code", "/:lang/confirmEmail/:code"])}
            {MultiRoute(<Terms_En />, ["/terms", "/en/terms"])}
            {MultiRoute(<Terms />, ["/se/terms"])}
            {MultiRoute(<Contact />, ["/contact/", "/:lang/contact"])}
            {MultiRoute(<Help />, ["/help/", "/:lang/help"])}
            {MultiRoute(<GDPR />, ["/gdpr/", "/:lang/gdpr"])}
            {MultiRoute(<Privacy_En />, ["/privacy-policy", "/:lang/privacy-policy"])}
            {MultiRoute(<Privacy />, ["/se/privacy-policy"])}
            {MultiRoute(<AdminPage />, ["/admin", "/:lang/admin"])}
            {MultiRoute(<AdminEmailTemplatesAndAutomation />, ["/emailTemplatesAndAutomation", "/:lang/emailTemplatesAndAutomation"])}
            {MultiRoute(<MemberFormSettings />, ["/memberFormSettings", "/:lang/memberFormSettings"])}
            {MultiRoute(<AdminEmailTemplates />, ["/emailTemplates", "/:lang/emailTemplates"])}
            {MultiRoute(<AdminAutomaticSending />, ["/automaticSending", "/:lang/automaticSending"])}
            {MultiRoute(<PublicSite />, ["/publicsite", "/:lang/publicsite"])}
            {MultiRoute(<UploadMembers />, ["/:companyurl/uploadmembers", "/:lang/:companyurl/uploadmembers"])}
            {MultiRoute(<UploadPayments />, ["/:companyurl/uploadPayments", "/:lang/:companyurl/uploadPayments"])}
            {MultiRoute(<NoChrome><PublicSiteLogin /></NoChrome>, publicSiteLoginPaths)}
            {MultiRoute(<NoChrome><PublicSiteLogin /></NoChrome>, publicSiteLoginWithCodePaths)}
            {MultiRoute(<NoChrome><PublicSiteLogin /></NoChrome>, publicSiteEditMemberLoginPaths)}
            {MultiRoute(
                <NoChrome><PublicSiteMemberLanding /></NoChrome>,
                publicSiteEditMemberPaths
            )}
            {MultiRoute(<NoChrome><PublicSiteNewMember /></NoChrome>, publicSiteNewMemberPaths)}
            {MultiRoute(<NoChrome><PublicSiteNewMemberActivateAccount /></NoChrome>, publicSiteNewMemberActivatePaths)}
            {MultiRoute(<NoChrome><PublicSiteConfirmEmailChange /></NoChrome>, publicSiteConfirmEmailChangePaths)}
            {MultiRoute(
                <NoChrome>
                    <PublicSiteMemberAuthGuard requireFullMember>
                        <PublicSiteMemberSearch />
                    </PublicSiteMemberAuthGuard>
                </NoChrome>,
                publicSiteMemberSearchPaths
            )}
            {MultiRoute(
                <NoChrome>
                    <PublicSiteMemberAuthGuard requireFullMember>
                        <PublicSiteFamilyMembersPage />
                    </PublicSiteMemberAuthGuard>
                </NoChrome>,
                publicSiteFamilyMembersPaths
            )}
            {MultiRoute(
                <NoChrome>
                    <PublicSiteMemberAuthGuard>
                        <PublicSitePaymentsPage />
                    </PublicSiteMemberAuthGuard>
                </NoChrome>,
                publicSitePaymentsPaths
            )}
            {MultiRoute(
                <NoChrome>
                    <PublicSiteMemberAuthGuard>
                        <PublicSiteEventsPage />
                    </PublicSiteMemberAuthGuard>
                </NoChrome>,
                publicSiteEventsPaths
            )}
            {MultiRoute(
                <NoChrome>
                    <PublicSiteMemberAuthGuard requireFullMember>
                        <PublicSiteCustomList />
                    </PublicSiteMemberAuthGuard>
                </NoChrome>,
                publicSiteCustomListPaths
            )}
            {MultiRoute(<NoChrome><PublicSiteResult /></NoChrome>, publicSiteResultPaths)}
            {/* Same fix as Login above: "/:lang/payments" is a literal, case-insensitive tie with the
                public "/:companyurl/payments" route — currently resolved by declaration order alone,
                which is fragile. Explicit en/se removes the ambiguity for good. */}
            {MultiRoute(<Payments />, ["/payments/", "/en/payments", "/se/payments"])}
            {MultiRoute(<PaymentConfirmation />, ["/payments/confirmation/:id", "/:lang/payments/confirmation/:id"])}
            {/* Swedish gets the redesigned page (partly hardcoded Swedish); the literal /se path outranks /:lang. */}
            {MultiRoute(<FeaturesMemberOrganisationsSe />, ["/se/features/organisations"])}
            {MultiRoute(<FeaturesMemberOrganisations />, ["/features/organisations", "/:lang/features/organisations"])}
            {MultiRoute(<MemberSystemForAssociationsPage />, ["/medlemsregister", "/:lang/medlemsregister"])}
            {MultiRoute(<MemberManagemenIntegrations />, ["/betalintegrationer", "/:lang/betalintegrationer"])}
            {MultiRoute(<MemberSystemSafety />, ["/gdpr-och-sakerhet", "/:lang/gdpr-och-sakerhet"])}



            {MultiRoute(<FeaturesCompanies />, ["/features/companies", "/:lang/features/companies"])}
            {MultiRoute(<AdminIntegrations />, ["/integrations", "/:lang/integrations"])}
            {MultiRoute(<FortnoxMismatchReport />, ["/integrations/mismatch-report", "/:lang/integrations/mismatch-report"])}
            {MultiRoute(<AdminIntegrations />, ["/integrations", "/:lang/integrations"])}
            {MultiRoute(<AdminIntegrations />, ["/integrations", "/:lang/integrations"])}
            {MultiRoute(<Backups />, ["/backup", "/:lang/backup"])}
            {MultiRoute(<AdminCreatePaymentLinks />, ["/createpaymentlinks", "/:lang/createpaymentlinks"])}
            {MultiRoute(<AdminCreateFortnoxInvoices />, ["/createfortnoxinvoices", "/:lang/createfortnoxinvoices"])}
            {MultiRoute(<AdminCreateSpirisInvoices />, ["/createspirisinvoices", "/:lang/createspirisinvoices"])}
            {MultiRoute(<AdminSendSmsCategory />, ["/sendSms", "/:lang/sendSms"])}
            {MultiRoute(<AdminSendSmsMember />, ["/sendSmsUser", "/:lang/sendSmsUser"])}
            {MultiRoute(<AdminSendSmsExternal />, ["/sendSmsExternal", "/:lang/sendSmsExternal"])}
            {MultiRoute(<PartnerFortnox />, ["/fortnox-integration", "/:lang/fortnox-integration"])}
            {MultiRoute(<PartnerSpiris />, ["/spiris-integration", "/:lang/spiris-integration"])}
            {MultiRoute(<PartnerPingPayments />, ["/pingpayment-integration-partner", "/:lang/pingpayment-integration-partner"])}
            {MultiRoute(<CreatePingPaymentIntegration />, ["/pingpayments-integration", "/:lang/pingpayments-integration"])}
            {MultiRoute(<PingPaymentPaymentReport />, ["/pingpayment-payment-report", "/:lang/pingpayment-payment-report"])}
            {MultiRoute(<CustomListSettings />, ["/customListsSettings", "/:lang/customListsSettings"])}
            {MultiRoute(<Views />, ["/views", "/:lang/views"])}
            {MultiRoute(<EditCustomList />, ["/editCustomList/:id", "/:lang/editCustomList/:id"])}
            {MultiRoute(<CustomList />, ["/customList/:id", "/:lang/customList/:id"])}
            {MultiRoute(<CustomList />, ["/customList/:id/edit/:editId", "/:lang/customList/:id/edit/:editId"])}
            {MultiRoute(<CustomList />, ["/customList/:id/add", "/:lang/customList/:id/add"])}
        </Routes>);
};

export default NavigationRoutes;